<template>
  <!-- 岗前培训课程详情 -->
	<div class="sign-train-detail">
    <div class="content-box" ref="content">
      <artcleDetail v-if="articleType == 1" ref="artcleDetailRefRef" :info='info' ></artcleDetail>
      <pdfDetail v-else-if="articleType == 4" ref="pdfDetailRef" :info='info' @complete="complete"></pdfDetail>
      <videoDetail v-else-if="articleType == 2" @refresh='getInfo' ref="videoDetailRef" :info='info' >
      </videoDetail>
    </div>
    <div class="bottom-box" :class="{ 'ok-style': isOKStyle }" @click="back">
      <div class="btn">继续学习</div>
    </div>
	</div>
</template>

<script>
	var timer,timeout;
	import artcleDetail from "./components/artcleDetail";
	import videoDetail from "./components/videoDetail";
	import pdfDetail from "./components/pdfDetail";
	import {common} from "@/api/mixins";
  import login from "./components/login.js";
	export default {
		props: {},
		components: {
			artcleDetail,
			videoDetail,
			pdfDetail
		},
		mixins: [common, login],
		data() {
			return {
        id:"",
				info: {},
				articleType: '',
        isOKStyle: false,
			};
		},
		computed: {},
		watch: {
		},
    beforeDestroy() {
			clearInterval(timer);
		},
		mounted() {
      const merchantNo = this.$route.query.merchantNo;
      this.isOKStyle = this.$tools.isOKbao(merchantNo) || this.$tools.isOKTX(merchantNo);
      this.checkLogin(false,true).then((res)=>{
        this.$weixin.hideMenu();
        this.id = this.$route.query.id;
        this.articleType = this.$route.query.articleType;
        this.getInfo();
      })
		},
		methods: {
      back(){
        // this.$router.push({
        //   path: "/apps/sign/train",
        //   query: {
        //     orgId:this.$route.query.orgId,
        //   }
        // });
        this.$router.back();
      },
			getInfo() {
				this.$http({
          type: "POST",
          url: "/api/userAuth/read/detail",
          data: {
            courseId: this.id,
            token:localStorage.regToken
          },
        }).then((res) => {
          // res.data.url = 'https://file.fxyf99.com/m3u8/video.m3u8'
          this.info = res.data;
          if(this.info.tag){
            this.info.tag = this.info.tag.split(',')
          }
          if (this.articleType == 1 || this.articleType == 4) {//文章或pdf
            if(this.info.learnStatus !=1 ){
              window.setTimeout(()=>{
                this.$refs.content.onscroll = this.scrollEnd;
                this.scrollEnd();
              },2000)
            }
            this.startTimer();
          }
          if(this.articleType == 1){//文章
            this.$nextTick(()=>{
              this.$refs.artcleDetailRefRef.init();
            })
          }
        }).catch((error) => {
          console.log(error)
        });
			},
      // 滚动底部
      scrollEnd(){
        const target = this.$refs.content;
        if(target.scrollHeight<=target.scrollTop+target.clientHeight+10){
          clearTimeout(timeout);
          timeout=window.setTimeout(this.complete,500)
        }
      },
      complete(){
        if(this.info.learnStatus == 1){
          return;
        }
        this.$http({
          type: "POST",
          url: "/api/userAuth/learnStatus",
          data: {
            courseId: this.id,
            learnStatus: 1,
            token:localStorage.regToken
          },
        }).then(res=>{
          this.info.learnStatus = 1
        })
      },
      // 启动轮询
      startTimer(){
        timer = window.setInterval(() => {
          this.$http({
            type: "POST",
            url: "/api/userAuth/learn",
            data: {
              courseId: this.id,
              intervalTime: 5,
              token:localStorage.regToken
            },
          })
        }, 5000)
      }
		},
	};
</script>

<style scoped lang="scss">
@import "./trainDetail.scss";
</style>
